import { useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  IonButton,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonModal,
  IonRefresher,
  IonRefresherContent
} from '@ionic/react';

import { getLoads } from '@/actions/loads';
import { getCompanyLocations } from '@/actions/locations';
import { titleize } from '@/helpers/humanize';
import { scanQRCode } from '@/helpers/qr_code';
import { STATES, STATE_CATEGORIES, DIRTY } from '@/helpers/loads';
import useResourceLoader from '@/hooks/useResourceLoader';
import Page from '@/pages/Page';
import LoadItem from '@/components/LoadItem';
import PrintLoadModal from '@/components/PrintLoadModal';

const CompanyLoadsPage = () => {
  const history = useHistory();
  const {category} = useParams();
  const dispatch = useDispatch();
  const loading = useResourceLoader(getLoads(), getCompanyLocations());
  const modal = useRef(null);

  const isCategory = _.includes(_.keys(STATE_CATEGORIES), category);
  const filterLoads = (loads) => {
    if (!isCategory) return _.filter(loads, {state: category});
    return _.filter(loads, ({state}) => _.includes(STATE_CATEGORIES[category], state));
  }
  const loads = useSelector((state) => _.groupBy(filterLoads(state.loads), 'state'));
  const locations = useSelector((state) => state.locations);

  const refresh = async (event) => {
    await dispatch(getLoads());
    event.target.complete();
  };

  return (
    <Page title={`${titleize(category)} Loads`}
      primaryButton={
        <IonButton onClick={scanQRCode(history, 'loads')} fill="solid">
          Scan
        </IonButton>
      }
      loading={loading}
    >
      <IonRefresher slot="fixed" onIonRefresh={refresh}>
        <IonRefresherContent></IonRefresherContent>
      </IonRefresher>

      {_.isEmpty(loads) && !loading && (
        <p className="ion-padding" style={{textAlign: 'center'}}>Nothing to see here</p>
      )}
      {STATES.map((state) => loads[state] && (
        <IonItemGroup key={state}>
          {isCategory && (
            <IonItemDivider sticky>
              <IonLabel>{titleize(state)}</IonLabel>
              {state === 'dirty' && (
                <IonButton size="small" fill="clear" color="secondary" style={{marginLeft: 'auto'}} id="open-print-modal">
                  Print All
                </IonButton>
              )}
            </IonItemDivider>
          )}
          {_.map(_.sortBy(loads[state], ['-updated_at']), (load) => (
            <LoadItem key={load.uuid} load={load}/>
          ))}
        </IonItemGroup>
      ))}

      {!_.isEmpty(loads[DIRTY]) && (
        <IonModal ref={modal} trigger="open-print-modal">
          <PrintLoadModal loads={loads[DIRTY]} locations={locations} dismiss={() => modal.current?.dismiss()}/>
        </IonModal>
      )}
    </Page>
  );
};

export default CompanyLoadsPage;
